<template>
    <div>
        <tab name="1"></tab>
        <div class="page-btns-box">
            <el-button v-if="params.parentId != 0" @click="$router.push(redirect)" icon="el-icon-back" size="small">返回上一级</el-button>
            <el-button v-if="$utils.have('/adminPrivilege/add')" type="primary" icon="el-icon-plus" @click="add" size="small">{{params.parentId != 0 ? '新增子权限' :'新增权限'}}</el-button>
        </div>
        <div v-if="parentData">父权限：{{parentData.name}}</div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
                row-key="id"
                class="sortable-table">
                <!-- <el-table-column v-if="parentData" label="父权限">{{parentData.name}}</el-table-column> -->
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column label="类型">
                    <template slot-scope="scope">
                        {{scope.row.type == 1 ? '链接' : '按钮'}}
                    </template>
                </el-table-column>
                <el-table-column prop="link" label="链接"></el-table-column>
                <el-table-column prop="sort" label="序号"></el-table-column>
                <el-table-column prop="behaviorType" label="行为类型">
                    <template slot-scope="scope">
                        {{scope.row.behaviorType && behaviorType.get(scope.row.behaviorType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="description" label="描述"></el-table-column>
                <el-table-column fixed="right" label="操作" width="260">
                    <template slot-scope="scope">
                        <el-button v-if="$utils.have('/adminPrivilege/edit')" type="text" size="small" icon="el-icon-edit" @click="edit(scope.row)">编辑</el-button>
                        <el-button type="text" size="small" icon="el-icon-tickets" @click="showChild(scope.row)">子权限</el-button>
                        <el-button v-if="$utils.have('/adminPrivilege/editStatus')" type="text" size="small" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button>
                        <el-button v-if="$utils.have('/adminPrivilege/correspondingRole')" type="text" size="small" icon="el-icon-view" @click="showRole(scope.row.id)">对应角色</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>  
        <edit ref="itemEdit"></edit>
        <role ref="roleList"></role>
    </div>
</template>
<script>
import Edit from './components/edit';
import Role from './components/role';
import tab from '../components/tab.vue'
import {getPrivileges} from '@/assets/js/commonApi';
import Sortable from "sortablejs";
    export default {
        components:{
            Edit, Role,tab
        },
        data(){
            return {
                dataList: [],
                params: {
                    parentId: this.$route.query.pid || 0
                },
                listLoading: true,
                redirect: this.$route.query.redirect || '/system/privilege/list',
                parentData:null,
                behaviorType: new Map([
                    [1,'新增'],[2,'管理'],[3,'页面访问'],[4,'导出'],[5,'导入'],[6,'登录']
                ])
            }
        },
        computed:{
            
        },
        mounted(){
            this.getDataList();
        },
        methods:{
            //获取列表
            async getDataList(){
                const  res = await getPrivileges(this.params).catch(() => {
                    this.$message.error('请求错误');
                }).finally(() => {
                    this.listLoading = this.params.parentId == 0 ? false : true;
                });
                const { state, msg, result } = res.data;
                if( state == 1 && result ){
                    this.dataList = result;
                    this.dataList = this.dataList.filter( (item) => item.status == 1 );
                    if( this.params.parentId && this.params.parentId != 0 ){
                        this.getDataDetail();
                    }
                    this.drag();
                }else{
                    this.$message.error(msg || '请求失败');
                }

            },
            //获取详情
            async getDataDetail(){
                const  res = await this.$request({
                    url: '/adminPrivilege/detail',
                    method: 'POST',
                    data:{id:this.params.parentId}
                }).catch(() => {
                    this.$message.error('父权限请求错误');
                }).finally(() => {
                    this.listLoading = false;
                });
                const { state, msg, result } = res.data;
                if( state == 1 && result ){
                    this.parentData = result
                }else{
                    this.$message.error(msg || '福权限请求失败');
                }
            },
            //查看子权限
            showChild(data){
                this.$router.push({
                    path:'/system/privilege/list',
                    query:{pid:data.id,redirect:this.$router.currentRoute.fullPath}
                })
            },
            //编辑事件
            edit(data){
                this.$refs.itemEdit.show(data);
            },
            //新增事件
            add(){
                this.$refs.itemEdit.show();
            },
            //删除事件
            del(id){
                this.$confirm('确定要删除吗?', '提示', {
                    type: 'warning',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.listLoading = true;
                    this.$request({
                        url: '/adminPrivilege/editStatus',
                        method: 'POST',
                        data: {id:id,status:0}
                    }).then(res => {
                        const { state, msg } = res.data;
                        if( state == 1 ){
                            this.getDataList();
                        }else{
                            this.$message.error(msg || '请求失败');
                        }
                    }).catch(() => {
                        this.$message.error('请求错误');
                    }).finally(() => {
                        this.listLoading = false;
                    });
                })
            },
            //查看对应角色
            showRole(id){
                this.$refs.roleList.show(id);
            },
            //拖拽排序
            drag(){
                this.$nextTick(() => {
                    const el = document.querySelectorAll('.sortable-table > .el-table__body-wrapper > table > tbody')[0];
                    Sortable.create(el, {
                        disabled: false, // 拖拽不可用? false 启用
                        ghostClass: 'sortable-ghost', //拖拽样式
                        animation: 150, // 拖拽延时，效果更好看
                        onEnd: (e) => { // 拖拽结束时的触发
                            let arr = [...this.dataList]; // 获取表数据
                            arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
                            
                            this.$nextTick(function () {
                                const a1 = (this.dataList.map(a => a.id)).toString();
                                const a2 = (arr.map(a => a.id)).toString();
                                if(a1 != a2){
                                    this.updateSort(arr);
                                }
                            })
                        },
                    });
                })
            },
            //排序
            updateSort(arrs){
                const _arr = [],arr = arrs;
                arr.map( (item,index) => {
                    item.sort = index + 1;
                    _arr.push({
                        id: item.id,
                        sort: item.sort
                    })
                })

                this.$request({
                    url: '/adminPrivilege/sort',
                    method: "post",
                    data: _arr,
                })
                    .then((res) => {
                        //处理成功回调
                        const { state, msg } = res.data;
                        if (state && state == 1) {
                            this.$message.success("排序成功");
                            this.dataList = arr;
                        } else {
                            return this.$message.error(msg || "操作失败");
                        }
                    })
                    .catch(() => {
                        this.$message.error("操作失败,请重试");
                    })
                    .finally(() => {
                        
                    });
            },
        }
    }
</script>